import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'HomeScreen',
  //   description: 'description of HomeScreen',
  //   url: '/home-screen',
  // },
];

export default help;
